import Vue from 'vue';

import { Dates } from './dates';
import { Enums } from './enums';
import { Images } from './images';
import { Lodash } from './lodash';
import { Numbers } from './numbers';
import { Print } from './print';
import { Services } from './services';
import { Store } from './store';

Vue.use(Store);

Vue.use(Dates);
Vue.use(Enums);
Vue.use(Images);
Vue.use(Lodash);
Vue.use(Numbers);
Vue.use(Print);
Vue.use(Services);
